import React from 'react';

class PendingReviewDetail extends React.Component {
    render() {
        return (
            <div>PENDING REVIEW DETAIL</div>
        );
    }
}

export default PendingReviewDetail;



/** WEBPACK FOOTER **
 ** ./src/components/PendingReviewDetail/PendingReviewDetail.js
 **/